import { Navigate, Outlet } from "react-router-dom";
import { Flex, Spinner } from "@chakra-ui/react";
import { useAuth } from "@/context/AuthContext";
import { colors } from "@/theme/colors";

// Guards feature routes by the two-tier gate: company entitlement (Tier 1)
// AND the caller's role access (Tier 2). Super-admin always passes.
export const RequireFeature = ({ feature }) => {
  const { hasFeature, featuresLoading, dataLoading, isSuperAdmin } = useAuth();

  // Super-admin always passes — never hold them on the feature-map spinner
  // (offline, the map may be unavailable while their access is unconditional).
  if (isSuperAdmin) return <Outlet />;

  if (dataLoading || featuresLoading) {
    return (
      <Flex minH="50vh" align="center" justify="center">
        <Spinner size="lg" color={colors.teal} borderWidth="3px" />
      </Flex>
    );
  }

  return hasFeature(feature) ? <Outlet /> : <Navigate to="/" replace />;
};
